import { Record } from 'immutable';

export const TeamResume = new Record({
  isPending: false,
  error: null,
  data: {}
});